import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { PaginationModel } from './../../shared';

@Injectable()
export class PaginationService {
    pagination = new PaginationModel();

    generatePageSeq(startIndex: number, recordsPerPage: number, totalRecords: number, visiblePageNums: number, range: number) {
        const edgePageSeq = visiblePageNums - range;

        this.pagination.currentPage = this.getCurrentPage(startIndex, recordsPerPage);
        this.pagination.totalPages = this.getTotalPages(recordsPerPage, totalRecords);
        this.pagination.isMobile = window.innerWidth < 767;

        this.pagination.initialPages = [];
        this.pagination.finalPages = [];
        this.pagination.middlePages = [];

        if (this.pagination.totalPages <= visiblePageNums || this.pagination.isMobile) {
            // if totalpages less than or equal to displaypage list out all pages also same sequence for mobile
            this.pagination.pageSeqType = 'all';
            this.pagination.initialPages = this.getPageNumbers(1, this.pagination.totalPages);
        } else if (this.pagination.currentPage + range <= edgePageSeq) {
            // this sequence edge in start have no middle links
            this.pagination.pageSeqType = 'start';
            this.pagination.initialPages = this.getPageNumbers(1, edgePageSeq);
            this.pagination.finalPages = this.getPageNumbers(this.pagination.totalPages - range + 1, this.pagination.totalPages);
        } else if (this.pagination.totalPages - this.pagination.currentPage + range < edgePageSeq) {
            // this sequence edge in end have no middle links
            this.pagination.pageSeqType = 'end';
            this.pagination.initialPages = this.getPageNumbers(1, range);
            this.pagination.finalPages = this.getPageNumbers(this.pagination.totalPages - edgePageSeq + 1,
            this.pagination.totalPages);
        } else {
            // this sequence have all links start, end and middle
            this.pagination.pageSeqType = 'middle';
            this.pagination.initialPages = this.getPageNumbers(1, range);
            this.pagination.middlePages = this.getPageNumbers(this.pagination.currentPage - range, this.pagination.currentPage + range);
            this.pagination.finalPages = this.getPageNumbers(this.pagination.totalPages - range + 1, this.pagination.totalPages);
        }

        return this.pagination;
    }

    getCurrentPage(startIndex: number, recordsPerPage: number): number {
        return Math.floor(startIndex / recordsPerPage) + 1;
    }

    getTotalPages(recordsPerPage: number, totalRecords: number): number {
        return Math.ceil(Math.max(totalRecords, 1) / Math.max(recordsPerPage, 1));
    }

    getPageNumbers(start, end){
        const arr: any = [];
        for (let i = start; i <= end; i++){
        arr.push(i);
        }
        return arr;
    }

    getPaginationContainerWidth(element, isMobile) {
        const lis =  element.getElementsByTagName('li');
        if (isMobile && lis.length) {
            const elementStyles = window.getComputedStyle(element);
            let cwidth = parseFloat(elementStyles.paddingLeft) + parseFloat(elementStyles.paddingRight);
            for (let actli of lis){
                const listyles = window.getComputedStyle(actli);
                cwidth += actli.offsetWidth + parseFloat(listyles.marginLeft) + parseFloat(listyles.marginRight);
            }
            element.getElementsByTagName('ul')[0].style.width = cwidth + 1 + 'px'; // Added 1px for rounding off width.
        } else {
            element.getElementsByTagName('ul')[0].style.width = 'auto';
        }
    }

    setPositionCenter(element) {
        const activeli =  element.getElementsByClassName('highlightCurrentPage');
        if (activeli.length) {
            const elementstyles = window.getComputedStyle(element);
            const conWidth = element.clientWidth - parseFloat(elementstyles.paddingLeft) - parseFloat(elementstyles.paddingRight);
            const elementLeft = activeli[0].offsetLeft;
            element.scrollLeft = elementLeft + (activeli[0].offsetWidth / 2) - (conWidth / 2);
        }
    }
}
